import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { MyPromise } from '../interceptors/myPromise.service';

const BASE_URL = `${environment.baseEndpoint}/payment`;

@Injectable({
  providedIn: 'root',
})
export class PaymentService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  createReferenceSpei(stationId: string, durationTime: number, customer: object) {
    return this.myPromise.to(this.http.post(`${BASE_URL}/spei/station/${stationId}`,  { durationTime, ...customer }));
  }

  createReferenceStore(stationId: string, durationTime: number, customer: object) {
    return this.myPromise.to(this.http.post(`${BASE_URL}/store/station/${stationId}`, { durationTime, ...customer }));
  }

  getHistoryByStationId(stationId: string) {
    return this.myPromise.to(this.http.get(`${BASE_URL}/station/${stationId}`));
  }
}
